import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { 
    generateDynamicRoutes, 
    getExistingRoutes, 
    debugDynamicRoutes 
} from '../utils/DynamicRouteGenerator';

/**
 * Hook personalizado para manejar rutas dinámicas
 * Optimizado para rendimiento con memoización
 */
export const useDynamicRoutes = (enableDebug = false) => {
    const menu = useSelector(state => state.menu.menu); // ✅ Corregido para coincidir con DashboardRoutes
    
    // Memoizar las rutas existentes (no cambian)
    const existingRoutes = useMemo(() => getExistingRoutes(), []);
    
    // Generar rutas dinámicas solo cuando el menú cambia
    const dynamicRoutes = useMemo(() => {
        if (!menu) {
            return [];
        }
        
        const routes = enableDebug 
            ? debugDynamicRoutes(menu, existingRoutes)
            : generateDynamicRoutes(menu, existingRoutes);
        
        return routes;
    }, [menu, existingRoutes, enableDebug]);
    
    return {
        dynamicRoutes,
        isLoading: !menu,
        hasRoutes: dynamicRoutes.length > 0
    };
};

/**
 * Hook para obtener información sobre una ruta específica
 */
export const useRouteInfo = (currentPath) => {
    const { dynamicRoutes } = useDynamicRoutes();
    
    const routeInfo = useMemo(() => {
        const isDynamicRoute = dynamicRoutes.some(route => route.path === currentPath);
        const routeData = dynamicRoutes.find(route => route.path === currentPath);
        
        return {
            isDynamic: isDynamicRoute,
            routeData,
            component: routeData?.component || null
        };
    }, [currentPath, dynamicRoutes]);
    
    return routeInfo;
};
